import { useEffect, useRef, useState } from 'react';
import { useNavigation } from 'react-router';

export const Progress = () => {
  const { state, location } = useNavigation();
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (state === 'loading') {
      setProgress(0);
      setVisible(true);

      let phase = 1;

      setTimeout(() => {
        setProgress(10);
      }, 100);

      setTimeout(() => {
        intervalRef.current = setInterval(() => {
          setProgress((prev) => {
            if (prev >= 85) return prev;

            if (phase === 1) {
              phase = 2;
            }

            if (phase === 2) {
              if (prev < 50) {
                return prev + Math.random() * 4;
              }
              phase = 3;
            }

            return prev + Math.random() * 2;
          });
        }, 300);
      }, 400);
    } else {
      if (intervalRef.current) clearInterval(intervalRef.current);

      setTimeout(() => {
        setProgress(100);
        setTimeout(() => setVisible(false), 400);
      }, 200);
    }

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [state, location]);

  if (!visible) return null;

  return (
    <div
      className="fixed left-0 top-0 h-1 bg-primary transition-all duration-500 ease-out"
      style={{
        width: `${progress}%`,
        opacity: progress === 100 ? 0 : 1,
        transition:
          progress === 100 ? 'opacity 0.4s ease-in-out' : 'width 0.3s ease-out',
      }}
    />
  );
};
